var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayoutWallet = function SvgPayoutWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3951",
    "data-name": "Rectangle 3951",
    width: 24,
    height: 24,
    transform: "translate(303 278)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_89",
    "data-name": "Mask Group 89",
    transform: "translate(-303 -278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(306 249.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10995",
    "data-name": "Group 10995",
    transform: "translate(0 35.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10994",
    "data-name": "Group 10994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32857",
    "data-name": "Path 32857",
    d: "M8.313,129.18v-1.187H1.188A1.189,1.189,0,0,0,0,129.18v2.375H8.563A10.632,10.632,0,0,1,8.313,129.18Z",
    transform: "translate(0 -127.992)",
    fill: "#74757d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10997",
    "data-name": "Group 10997",
    transform: "translate(0 41.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10996",
    "data-name": "Group 10996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32858",
    "data-name": "Path 32858",
    d: "M18.951,287.992a10.681,10.681,0,0,1-3.814,3.326,1.784,1.784,0,0,1-1.771,0,10.734,10.734,0,0,1-3.815-3.329H0v5.938a1.189,1.189,0,0,0,1.188,1.188H17.813A1.188,1.188,0,0,0,19,293.929v-5.937ZM5.344,291.555H2.969a.594.594,0,0,1,0-1.188H5.344a.594.594,0,0,1,0,1.188Z",
    transform: "translate(0 -287.992)",
    fill: "#74757d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10999",
    "data-name": "Group 10999",
    transform: "translate(9.5 32.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10998",
    "data-name": "Group 10998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32859",
    "data-name": "Path 32859",
    d: "M265.14,33.837l-4.156-1.781a.6.6,0,0,0-.469,0l-4.156,1.781a.592.592,0,0,0-.359.545v2.375c0,3.267,1.208,5.176,4.454,7.047a.6.6,0,0,0,.591,0c3.247-1.866,4.454-3.775,4.454-7.047V34.382A.592.592,0,0,0,265.14,33.837ZM263,36.535,260.621,39.5a.6.6,0,0,1-.464.222h-.025a.6.6,0,0,1-.469-.264l-1.187-1.781a.593.593,0,1,1,.988-.658l.737,1.106,1.867-2.335a.594.594,0,0,1,.929.741Z",
    transform: "translate(-256 -32.008)",
    fill: "#74757d"
  })))))));
};
export default SvgPayoutWallet;